import { motion } from 'framer-motion'
import styled from 'styled-components'

import { VisibleScrollbarStyle } from '@/styles/scrollbar'

const StContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
  ${VisibleScrollbarStyle}
`

const StHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: ${({ theme }) => theme.UI.SpacingPx.Space6};
`

const StContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`

const AnimatedContainer = motion(StContainer)

export { AnimatedContainer, StContent, StHeader }
